import TabPanel from "../../../components/TabPanel";

import { useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Box, Typography, Divider, Button, Paper } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import FaceIcon from "@mui/icons-material/Face";
import Chip from "@mui/material/Chip";
// import LoginInfoBox from "./Boxs/LoginInfoBox"
// import UserInfoBox from "./Boxs/UserInfoBox"
// import ChangePhoneNumber from "./Boxs/ChangePhoneNumber"
// import EditUserName from "./Boxs/EditUserName"
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AppSettingsAltIcon from "@mui/icons-material/AppSettingsAlt";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Tooltip from "@mui/material/Tooltip";
import UploadsSubtitles from "./Boxs/UploadsSubtitles/UploadsSubtitles";
import UploadsMultiSubtitles from "./Boxs/UploadsMultiSubtitles/UploadsMultiSubtitles";
import DragDropUploadsMultiSubtitles from "./Boxs/DragDropUploadsMultiSubtitles/DragDropUploadsMultiSubtitles";
import DragDropUploadsSerialMultiSubtitles from "./Boxs/DragDropUploadsSerialMultiSubtitles/DragDropUploadsSerialMultiSubtitles";
import SearchSubtitles from "./Boxs/SearchSubtitles/SearchSubtitles";
import EditSubtitles from "./Boxs/EditSubtitles/EditSubtitles";
import RemoveSubtitles from "./Boxs/RemoveSubtitles/RemoveSubtitles";
import AccessDeny from "../AccessDeny";

function SubtitlesTabs(props) {
  const { subtitlesTabsValue, userTypes } = props;

  return (
    <Box component="main">
      <TabPanel value={subtitlesTabsValue} index={0}>
        <UploadsSubtitles />
      </TabPanel>
      <TabPanel value={subtitlesTabsValue} index={1}>
        <SearchSubtitles />
      </TabPanel>
      <TabPanel value={subtitlesTabsValue} index={2}>
        <EditSubtitles />
      </TabPanel>
      <TabPanel value={subtitlesTabsValue} index={3}>
        <RemoveSubtitles />
      </TabPanel>
      <TabPanel value={subtitlesTabsValue} index={4}>
        <UploadsMultiSubtitles />
      </TabPanel>
      <TabPanel value={subtitlesTabsValue} index={5}>
        {userTypes.indexOf("admin") >= 0 || userTypes.indexOf("adminGod") >= 0 || userTypes.indexOf("subtitlesManager") >= 0 ?
          <DragDropUploadsMultiSubtitles /> :
          <>
            <Paper sx={{ textAlign: "center", mt: 2, color: "red" }}>
              <Typography sx={{ p: 2, fontSize: "xx-large" }}>
                دسترسی به این بخش نیاز به کاربری مخصوص دارد
              </Typography>
            </Paper>
            <AccessDeny />
          </>
        }

      </TabPanel>
      <TabPanel value={subtitlesTabsValue} index={6}>
        {userTypes.indexOf("admin") >= 0 || userTypes.indexOf("adminGod") >= 0 || userTypes.indexOf("subtitlesManager") >= 0 ?
          <DragDropUploadsSerialMultiSubtitles /> :
          <>
            <Paper sx={{ textAlign: "center", mt: 2, color: "red" }}>
              <Typography sx={{ p: 2, fontSize: "xx-large" }}>
                دسترسی به این بخش نیاز به کاربری مخصوص دارد
              </Typography>
            </Paper>
            <AccessDeny />
          </>
        }

      </TabPanel>
    </Box>
  );
}

export default SubtitlesTabs;
